import { getLabel } from '@/utils/locale'
import React, { ComponentType, ReactElement } from 'react'
import HomeWrapper from './style'
import Footer from './component/Footer'
import { useNavigate } from 'react-router'
import { useEffect } from 'react'
import ItemList from './component/ItemList'
function Home() {
  return (
    <HomeWrapper className="log-home">
      <div>
        {/* 主要签名信息 */}
        <div className="container">
          <div className="title animate__animated animate__backInDown border border-light">
            Xupingyuan
          </div>
          {/* 中间底下小圆点内容 */}
          <div className="circle">
            <div className="circle-item"></div>
            <div className="circle-item"></div>
            <div className="circle-item"></div>
            <div className="circle-item"></div>
            <div className="circle-item"></div>
          </div>
        </div>
        {/* <ItemList/> */}
      </div>
      <Footer />
    </HomeWrapper>
  )
}

const withLogin = (Cmp: () => ReactElement) => {
  // eslint-disable-next-line react/display-name, @typescript-eslint/no-explicit-any
  return (props: any) => {
    const navigate = useNavigate()
    useEffect(() => {
      navigate('/login', { replace: true })
    }, [])
    return <Cmp {...props}></Cmp>
  }
}

export default Home
